const MAX_UPLOAD_FILE_BYTES = 20 * 1024 * 1024;

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

/**
 * Uploads an image or general document to /api/upload_file and resolves with its public URL.
 * @param {File} file
 * @returns {Promise<string>} the uploaded file's URL
 */
export async function uploadFile(file) {
  if (!file) {
    throw new Error('No file selected');
  }
  if (file.size > MAX_UPLOAD_FILE_BYTES) {
    throw new Error('File exceeds the 20MB limit');
  }

  const dataUrl = await readFileAsDataUrl(file);

  const response = await fetch('/api/upload_file', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      file: dataUrl,
      fileName: file.name,
      contentType: file.type,
    }),
  });

  const payload = await response.json();
  if (!response.ok || payload.responsecode !== 200) {
    throw new Error(payload.message || 'File upload failed');
  }

  return payload.url;
}
